import { createReducer, on } from '@ngrx/store';
import { InvestigatorState } from '@shared/interfaces/investigatorstate.interface';
import {
  resetAllInvestigatorFields,
  resetOtherInvestigatorInformationFields,
  setInvestigatorInformation,
} from '../actions/investigator.action';

export const initialState: InvestigatorState = {
  investigatorId: '',
  firstName: '',
  lastName: '',
  middleName: '',
  suffix: '',
  address1: '',
  address2: '',
  address3: '',
  city: '',
  state: {},
  province: '',
  stateProvinceName: '',
  country: {},
  zip: '',
  emailAddress: '',
  phoneNumber: '',
  npi: '',
  specialties: [],
  degrees: [],
  isNewInvestigator: false,
};

export const investigatorReducer = createReducer(
  initialState,
  on(setInvestigatorInformation, (state, { investigatorInfo }) => ({
    ...state,
    ...investigatorInfo,
  })),
  on(resetAllInvestigatorFields, () => ({
    ...initialState,
  })),
  on(resetOtherInvestigatorInformationFields, (state) => ({
    ...state,
    npi: '',
    specialties: [],
    degrees: [],
  })),
);
